app.factory('questionService', function(
    $rootScope,
    objectService,
    designLineService,
    imageService
) {
    var object,
        groups,
        disabled = [],
        meta = {
            currentGroup:    0,
            currentQuestion: 0
        },
        subsequentGoTo = null

    function setMeta(){
        meta.group              = groups[meta.currentGroup];
        meta.question           = meta.group.questions[meta.currentQuestion];
        meta.isFirst            = control.isFirst();
        meta.isLast             = control.isLast();

        $rootScope.$broadcast('questionChangedEvent',meta.question);
    }

    function checkSkip(){
        var skip = objectService.isGroupDisabled(meta.group)
            || meta.group.hidden
            || objectService.isQuestionDisabled(meta.question)
            || meta.question.hidden

        if(skip && meta.isFirst){
            control.next();
            return false;
        }

        if(skip && meta.isLast){
            control.prev();
            return false;
        }

        return skip;
    }

    var control = {
        getNextQuestion: function(){
            var i,j,qs,ip; // ip = initial position
            for(i=meta.currentGroup,ip=true ; i<meta.groups.length ; i++){
                if(meta.groups[i].hidden || objectService.isGroupDisabled(meta.groups[i])) continue;
                qs = meta.groups[i].questions;
                for(j=ip?meta.currentQuestion:0; j<qs.length ; j++){
                    if (!ip && !(qs[j].hidden || objectService.isQuestionDisabled(qs[j]))){
                        return {'group':i,'question':j};
                    }
                    ip = false;
                }
            }

            return false;
        },
        getPreviousQuestion: function(){
            var i,j,qs,ip; // ip = initial position
            for(i=meta.currentGroup,ip=true ; i>=0 ; i--){
                if(meta.groups[i].hidden || objectService.isGroupDisabled(meta.groups[i])) continue;
                qs = meta.groups[i].questions;
                for(j=ip?meta.currentQuestion:qs.length-1; j>=0 ; j--){
                    if(!ip && !(qs[j].hidden || objectService.isQuestionDisabled(qs[j]))){
                        return {'group':i,'question':j};
                    }
                    ip = false;
                }
            }

            return false;
        },
        gotoGroup: function(group, onlyChangeGroup){
            meta.currentGroup = 0
            if(!angular.isNumber(group)){
                angular.forEach(meta.groups, function(g, key){
                    if(g.id == group.id) meta.currentGroup = key
                })
            } else {
                meta.currentGroup = group;
            }
            meta.currentQuestion = 0;

            setMeta()
            if(onlyChangeGroup) return
            if(checkSkip()) control.next()
        },
        gotoQuestion: function(group,question){
            control.gotoGroup(group, true)
            meta.currentQuestion = 0
            if(!angular.isNumber(question)){
                angular.forEach(meta.group.questions, function(mquestion, key){
                    if(mquestion.id == question.id) meta.currentQuestion = key
                })
            } else {
                meta.currentQuestion = question;
            }

            setMeta()
            if(checkSkip()) control.next()
        },
        next: function (){
            var next = control.getNextQuestion()
            if(next){
                control.gotoQuestion(next.group,next.question);
            }
        },
        prev: function(){
            if(prev = control.getPreviousQuestion()){
                control.gotoQuestion(prev.group,prev.question);
            }
        },
        isFirst: function(){
            return !control.getPreviousQuestion();
        },
        isLast: function(){
            return !control.getNextQuestion();
        }
    };

    return {
        meta: meta,
        control: control,
        initBase : function() {
            object = objectService.getObject()
            groups = objectService.getQuestionGroups()
            this.hideQuestionsWithOneAlternative()
        },
        initChoices: function(initial) {
            this.initBase()
            this.initMeta()
        },
        hideEarlyChoices: function(){
            angular.forEach(groups, function(group){
                angular.forEach(group.questions, function(question){
                    if(question.type === 'early') question.hidden = true
                })
            })
            this.hideGroupsWithNoQuestions()
        },
        hideQuestionsWithOneAlternative: function() {
            angular.forEach(groups, function(group){
                angular.forEach(group.questions, function(question){
                    if(question.type != QUESTION_TYPE.MULTIPLE) return
                    if(!question.alternatives.length){
                        debug('Hide question "%s" (no alternatives):',question.title, question);
                        question.hidden = true
                    }
                    else if (question.alternatives.length < 2) {
                        /**
                         * Do something about this setting the answer? save it? do it in objectService?
                         */
                        question.answer = question.alternatives[0].id
                        question.hidden = true
                        debug('Hide question "%s" (only one alternatives):',question.title, question);
                    }
                })
            })
            this.hideGroupsWithNoQuestions()
        },
        hideGroupsWithNoQuestions: function() {
            angular.forEach(groups, function(group){
                var hidden = true
                angular.forEach(group.questions, function(question){
                    if(!question.hidden) hidden = false
                })
                group.hidden = hidden
            })
        },
        initMeta: function() {
            var firstGroupIndex = null,
                firstQuestionIndex = null

            angular.forEach(groups, function(group, i){
                if(!group.hidden && firstGroupIndex === null)
                    firstGroupIndex = i
            })

            angular.forEach(groups[firstGroupIndex].questions, function(question, i){
                if(!question.hidden && firstQuestionIndex === null)
                    firstQuestionIndex = i
            })

            angular.extend(meta, {
                groups: groups,
                currentGroup: firstGroupIndex,
                group: groups[firstGroupIndex],
                currentQuestion: firstQuestionIndex,
                question: groups[firstGroupIndex].questions[firstQuestionIndex]
            })

            setMeta()

            if(!!subsequentGoTo) {
                control.gotoQuestion(subsequentGoTo.group, subsequentGoTo.question)
                subsequentGoTo = null
            }
        },
        setSubsequentGoTo: function(group, question) {
            subsequentGoTo = {
                group: group,
                question: question
            }
        }
    };

});
